import type { ReportFileVariant } from '../../domain/report';
import { isReportFileVariant } from '../../domain/report';
import type { MessageKey } from '../../i18n/i18n';
import type { IconName } from '../../ui/icons';

// What each kind of delivered PDF is called in the lists (the report screen, the account's reports).
export const REPORT_FILE_LABEL: Record<ReportFileVariant, MessageKey> = {
  clientEnglish: 'report.variantClient',
  selfChinese: 'report.variantSelf',
  clientChineseSummary: 'report.variantClientSummary',
  agreement: 'report.variantAgreement',
  addendum: 'report.variantAddendum'
};

export function reportFileLabelKey(variant: string): MessageKey {
  return isReportFileVariant(variant) ? REPORT_FILE_LABEL[variant] : 'report.variantClient';
}

export function reportFileIcon(variant: string): IconName {
  return variant === 'agreement' ? 'contract' : variant === 'addendum' ? 'edit_note' : 'picture_as_pdf';
}
